import 'what-input'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueGtag from 'vue-gtag'
import smoothscroll from 'smoothscroll-polyfill'
import { StripePlugin } from '@vue-stripe/vue-stripe'

import '@/styles/bootstrap/index.scss'
import '@/styles/global/index.scss'

import config from './config'
import router from './router'
import store from './store'
import { ApiPlugin } from './plugins/api'

import '@/mixins/global'
import '@/utils/filters'
import '@/utils/directives'

import app from '@/components/app/app.vue'
import loader from '@/components/loader/loader.vue'
import errorMessage from '@/components/error-message/error-message.vue'

smoothscroll.polyfill()

Vue.use(ApiPlugin)
Vue.use(StripePlugin, {
  pk: config.STRIPE_PUBLISHABLE_KEY,
  apiVersion: '2022-11-15',
  locale: 'en-GB'
})
Vue.use(VueGtag, {
  config: { id: 'G-RVKN8QJGCW' },
  includes: [{ id: 'UA-197637611-1' }]
})
Vue.use(VueMeta)

Vue.component('loader', loader)
Vue.component('errorMessage', errorMessage)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(app)
}).$mount('#app')
